<template>
  <div>

    <Card :dis-hover="true">
      <div class="search-panel">
        <ul class="list-group">
          <li class="list-group-item">
            <div class="item-label">平台: </div>
            <ul class="item-list">
              <li><span @click="selectitem('connector', 'lazada')" :class="{ active: filter.connector=='lazada' }" class="option-item">lazada</span></li>
              <li><span @click="selectitem('connector', 'shopee')" :class="{ active: filter.connector=='shopee' }" class="option-item">shopee</span></li>
            </ul>
          </li>
          <li class="list-group-item">
            <div class="item-label">店铺: </div>
            <ul class="item-list">
              <li @click="selectitem('store_id', item.id)" v-for="(item, index) in stores[filter.connector]" :key="index"><span :class="{ active: item.active==true }" class="option-item">{{item.name}}</span></li>
            </ul>
          </li>
        </ul>
      </div>
      <Divider dashed />
      <Table :loading="loading" :columns="columns" :data="data" height="400">
        <template slot-scope="{ row }" slot="title">
            <p class="statis-row">{{ row.title }}</p>
            <p v-if="row.desc" class="statis-row">({{ row.desc }})</p>
        </template>
        <template slot-scope="{ row, index }" slot="F1">
            <p :data-index="index" v-if="row.F1 == 0" class="statis-row">{{ row.F1 }}人</p>
            <p :data-index="index" @click="buyerList(row.index, 1)" style="cursor: pointer;" v-if="row.F1 > 0" class="statis-row">{{ row.F1 }}人</p>
            <p class="statis-row">{{ row.F1_percentage }}%</p>
        </template>
        <template slot-scope="{ row }" slot="F2">
            <p v-if="row.F2 == 0" class="statis-row">{{ row.F2 }}人</p>
            <p @click="buyerList(row.index, 2)" style="cursor: pointer;" v-if="row.F2 > 0" class="statis-row">{{ row.F2 }}人</p>
            <p class="statis-row">{{ row.F2_percentage }}%</p>
        </template>
        <template slot-scope="{ row }" slot="F3">
            <p v-if="row.F3 == 0" class="statis-row">{{ row.F3 }}人</p>
            <p @click="buyerList(row.index, 3)" style="cursor: pointer;" v-if="row.F3 > 0" class="statis-row">{{ row.F3 }}人</p>
            <p class="statis-row">{{ row.F3_percentage }}%</p>
        </template>
        <template slot-scope="{ row }" slot="F4">
            <p v-if="row.F4 == 0" class="statis-row">{{ row.F4 }}人</p>
            <p @click="buyerList(row.index, 4)" style="cursor: pointer;" v-if="row.F4 > 0" class="statis-row">{{ row.F4 }}人</p>
            <p class="statis-row">{{ row.F4_percentage }}%</p>
        </template>
        <template slot-scope="{ row }" slot="F5">
            <p v-if="row.F5 == 0" class="statis-row">{{ row.F5 }}人</p>
            <p @click="buyerList(row.index, 5)" style="cursor: pointer;" v-if="row.F5 > 0" class="statis-row">{{ row.F5 }}人</p>
            <p class="statis-row">{{ row.F5_percentage }}%</p>
        </template>
        <template slot-scope="{ row }" slot="total">
            <p class="statis-row">{{ row.total }}人</p>
            <p class="statis-row">{{ row.total_percentage }}%</p>
        </template>
        
      </Table>
      <div class="page-wrap">            
        <Page :total="total" @on-change="switchPage" @on-page-size-change="switchPagesize" show-sizer />
      </div>
    </Card>
     
<Modal
    v-model="buyerListModel"
    title="买家列表"
    :footer-hide="true"
    width="80%"
    >
  <BuyerList ref="buyerListElem"></BuyerList>
</Modal>

  </div>
</template>
<script>
import conf from "@/views/im/conf";
import RequestUtils from "@/utils/RequestUtils";
import EventBus from "@/utils/eventBus";
import BuyerList from "./components/buyerList.vue";

export default {
  components: {
    BuyerList
  },
  data() {
    return {
      buyerListModel: false,
      loading: false,
      total: 0,
      curPage: 1,
      pageSize: 10,
      searchfield: 'name',
      searchval: '',
      filter: {
        connector: 'lazada',
        store_id: 0
      },
      columns: [
          {
              title: 'RFM model',
              slot: 'title'
          },
          {
              title: 'F = 1 (购买1次)',
              slot: 'F1'
          },
          {
              title: 'F = 2 (购买2次)',
              slot: 'F2'
          },
          {
              title: 'F = 3 (购买3次)',
              slot: 'F3'
          },
          {
              title: 'F = 4 (购买4次)',
              slot: 'F4'
          },
          {
              title: 'F >= 5 (购买5次以上)',
              slot: 'F5'
          },
          {
              title: '行合计',
              slot: 'total'
          },
          
      ],
      data: [
        
      ]
    }
  },
  computed: {
    stores: {
      get: function() {
        return this.$store.state.storeOpt;
      }
    }
  },
  methods: {
    selectitem (key, value) {
      if (key == 'store_id') {
        this.$store.commit("activeStoreOptById", {
          platform: this.filter.connector,
          id: value
        });
      }
      this.filter[key] = value;
      this.request();
    },
    switchPage (index) {
      this.curPage = index;
      this.request();
    },
    switchPagesize (size) {
      this.pageSize = size;
    },
    buildparams () {
      let filter = JSON.parse(JSON.stringify(this.filter));
      if (this.searchval) {
        filter[this.searchfield] = this.searchval;
      }

      let param = new FormData();
      param.set("limit", this.pageSize);
      param.set("offset", (this.curPage-1)*this.pageSize );
      for (let key in this.filter) {
        param.set(key, this.filter[key] );
      }
      return param;
    },
    request () {
      let self = this;
      self.loading = true;
      RequestUtils.request(conf.getBuyerModel(), self.buildparams())
      .then(data => {
        self.total = data.total;
        self.data = data.rows;
        self.loading = false;
      })
    },
    // 买家列表
    buyerList(index, column) {
      this.buyerListModel = true;
      this.$refs.buyerListElem.curPage = 1;
      this.$refs.buyerListElem.setStore(this.filter.store_id);
      this.$refs.buyerListElem.filter.row_index = index;
      this.$refs.buyerListElem.filter.purchase_state = column;
      this.$refs.buyerListElem.request();
    },
  },
  created() {
    this.request();
    EventBus.$on('openSession', () => {
      this.buyerListModel = false;
    })
    EventBus.$on('openBuyerList', () => {
      console.log('openBuyerList');
      this.buyerListModel = true;
    })
  }
};
</script>
<style lang="scss" scoped>
@import "@/static/styles/theme";

.ivu-tabs-content {
  height: 100%;
}
.page-wrap {
  padding-top: 3rem;
}
.statis-row {
  line-height: 30px;
}
.search-panel {
  padding: 2rem;

  .list-group-item {
    display: flex;
    align-items: center;
    border: 0px;
    position: relative;
    padding: 10px 0px;

    .item-label {
      width: 90px;
    }

    .item-list {
      padding: 0px;
      max-height: 120px;
      overflow: scroll;
      overflow-x: hidden;

      li {
        display: inline-block;
        margin: 0px 3px;
        cursor: pointer;
        color: #428bca;

        .option-item {
          padding: 2px 5px;
          border-radius: 3px;
        }
        .option-item.active {
          background: #428bca;
          color: #fff;
        }
      }
    }
  }
}

.panel-box {
  width: 26rem;
  background-color: $color-light-gray;
  height: 100%;
  display: flex;
  flex-direction: row;

  .chat-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    position: relative;

    .layout-main {
      height: 100%;
      overflow-y: scroll;
      padding: 1rem;
      
    }
  }

  
}
</style>
